import { useTranslation } from '../../i18n';

interface DirectionalIconProps {
  icon: string;
  style?: React.CSSProperties;
  className?: string;
}

export function DirectionalIcon({ icon, style, className }: DirectionalIconProps) {
  const { direction } = useTranslation();

  const iconMap: Record<string, string> = {
    'arrow_forward': 'arrow_back',
    'arrow_back': 'arrow_forward',
    'chevron_right': 'chevron_left',
    'navigate_next': 'navigate_before',
  };

  const displayIcon = direction === 'rtl' ? (iconMap[icon] || icon) : icon;

  return (
    <span
      className={`material-symbols-outlined ${className || ''}`}
      style={style}
    >
      {displayIcon}
    </span>
  );
}
